import apiUrl from '../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import PageTracker from '../../../../common/PageTrackerHelper'
import keycloak from '../../../../common/Keycloak';

import {
  BasicSelect
} from 'vue-search-select';


export default {
  name: 'FinanceApprove',
  components: {
      BasicSelect,
      VueElementLoading,
      Paginate
  },
  mixins:[PageTracker],
  data: function() {
      return {
        fromDate:'',
          toDate:'',
          debitFrom:'',
          debitFromType:'',
          hubname:'',
          staffDebit:'',
          shippingID:'',
          employeeID:'',
          SRAgencyName:'',
          HRDebitData:[],
          HRApproveAllRecord:false,
          selectedItems: [],
          selectAllItems: false,
          searchflag:false,
          raiseHRDebitNotePopupflag:false,
          flagforpopup:false,
          shipmetDeatileFlag:false,
          paymentOption:"totalPayment",
          comment:'',
          DetailsofMarkedDebit:[],
          shippingDetailes:{},
          shipingInfo:[],
          employeeTypeList:[],
          hubList: [],
          hublistObj:{value: "",text: ""},
          SuperAgentType:'',
          SuperAgentTypeData:[],
          loader: false,
          hubID :'',
          SRAgencyList : [],
          getEmpList : [],
          customizedDebitValueData : [],
          customizedDebitValue : 5000,
          pageno: 1,
          pagecount: 0,
          localusermailid:'',
          customizedDebitErrorFlag :true,
          status:'',
          loader:'<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
          srLoader:'',
          debitFromList:[{ value: "ServiceCenter",text: "Service Center"},{ value: "Courier",text: "Super Agent"},{ value: "Coloader",text: "Coloader "},{ value: "Vendor",text: "Local Vendor"},{ value: "NetworkVendor",text: "Network Vendor"}],
          debitFromObj:{ value: "",text: ""},
          StatusList:[
            { value: "HRCloseDebit",text: "HR Close Debit"},{ value: "transitApproved",text: "InTransit Approve"},{ value: "AccountCloseDebit",text: "Account Closed"},{ value: "RSCApprovedPending",text: "RSC Approved"}],
          StatusObj:{ value: "",text: ""},
          debitFromTypeList:[],
          debitFromTypeObj:{ value: "",text: ""},
          SuperAgentObj:{ value: "",text: ""},
          debitMode:"",
          debitModeList:[],
          debitModeObj:{ value: "",text: ""},
          Coloader:"",
          ColoaderList:[],
          ColoaderObj:{ value: "",text: ""},
          localVendor:"",
          localVendorList:[],
          localVendorObj:{ value: "",text: ""},
          NetworkVendor:"",
          NetworkVendorList:[],
          NetworkVendorObj:{ value: "",text: ""},
          SRAgencyObj:{ value: "",text: ""},
          hubArray:[],
          EmpTypeArray:[],
          SuperAgentArray:[],
          transactionStatus: false,
          staffDebitObj: [],
          ApproveResultResponse: [],
          invoiceNo: '',
          attachmentLoader: false,
          getAttachmentFlag: false,
          getAttachmentListData: [],
          totalRecords:0,
          exportFlag:false,
          exportCSVData:[],
          debitNoteId : [],
          Vertical : '',
          userDataKey : '',
          getInvestigationImgs: []
      }
  },
  created: function() {
  },
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.hubID = userdetail.hubdetails[0]
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    // this.getSuperAgentList();
      //this.HRApproveFilter();
      this.getEmployeeType();
      this.getHubList('hubList');
      this.getSRAgencyList(this.hubID);
      this.getEmpListing()

  },
  onChange: {
    type: Function,
      default: function (val) {
          this.$emit('input', val)
      }
    },
    filters: {
      isnull: function(val) {
        if (val == null || val == '' || val =="null")
          return '--'
        return val;
      }
    },
    methods: {

      getDebitFrom(obj){
        this.debitFromObj = obj
        this.debitFrom = this.debitFromObj.value
        this.debitModeList = []
        //debitFromList:[{ value: "Coloader",text: "Coloader"},{ value: "Vendor",text: "Local Vendor"},{ value: "NetworkVendor",text: "Network Vendor"}],
        this.srDebitOnChangeReset()
        this.coloaderReset()
        this.superAgentReset()
        this.networkVendorReset()
        this.VehicleVendorReset()
        this.clearDebitData()
       if(this.debitFrom == "ServiceCenter"){
         this.debitModeList = [{ value: "Salary",text: "Salary "},{ value: "Cash In Hand",text: "Cash In Hand "}]
         this.getSRAgencyList(this.hubname, '');
       }else if(this.debitFrom == "Courier"){
         this.debitModeList = [{ value: "Cash In Hand",text: "Cash In Hand "},{ value: "Cash Against Invoice",text: "Cash Against Invoice "},{ value: "COF",text: "COF "},{ value: "Cheque",text: "Cheque "}]
         this.getSuperAgentList()
       }else{
         this.debitModeList = [{ value: "Cash In Hand",text: "Cash In Hand "},{ value: "Cash Against Invoice",text: "Cash Against Invoice "},{ value: "COF",text: "COF "}]
       }
    },
      getDebitMode(obj){
      this.debitModeObj = obj
      this.debitMode = this.debitModeObj.value
    },
      getColoader(obj){
      this.ColoaderObj = obj
      this.Coloader = this.ColoaderObj.value
    },
      getLocalVendor(obj){
      this.localVendorObj = obj
      this.localVendor = this.localVendorObj.value
    },
      getNetworkVendor(obj){
      this.NetworkVendorObj = obj
      this.NetworkVendor = this.NetworkVendorObj.value
    },
      getSRAgency(obj){
      this.SRAgencyObj = obj
      this.SRAgencyName = this.SRAgencyObj.value
    },
      getdebitFromTypeObject(obj){
      this.debitFromTypeObj = obj
      this.debitFromType = this.debitFromTypeObj.value
      this.getSRAgencyList(this.hubname,this.debitFromType)
    },
      getStatus(obj){
      this.StatusObj = obj
      this.status = obj.value
    },
      gethubname(obj){
      this.hublistObj = obj
      this.hubname = this.hublistObj.value
      this.debitFromTypeObj = {value:"",text:""}
      this.debitFromType = ""
      this.getSRAgencyList(this.hubname,this.debitFromType)
      this.getSuperAgentList();
    },
      getSuperAgent(obj){
      this.SuperAgentObj = obj
      this.SuperAgentType = this.SuperAgentObj.value
    },
    getSelectDebitSRStaff(obj){
      this.staffDebitObj = obj
      this.staffDebit = obj.value
    },
    refreshdata() {
      this.selectedItems = [];
      this.pageno = 1;
      this.$refs.paginate.selected= 0;
      this.ApproveResultResponse = [];
      this.exportFlag = false
      this.HRApproveFilter();
    },
    clearDebitData() {
      this.debitModeObj = {},
      this.debitMode = ""
    },
    searchData() {
      this.searchflag = true;
      this.pageno = 1;
      this.$refs.paginate.selected= 0;
      this.HRApproveFilter();
    },
    HRApproveFilter(){
        this.searchflag=true;
        this.loader = true;
        this.selectedItems = []
        let payload = {};
        if(this.fromDate != '') payload.fromDate = this.getFormatedDate(this.fromDate);
        if(this.toDate != '') payload.toDate = this.getFormatedDate(this.toDate);
        if(this.debitFrom != '') payload.debitFrom = this.debitFrom;
        if(this.hubname != '') payload.ServiceCenterName = this.hubname.toString();
        if(this.employeeID != '') payload.EmployeeID = this.employeeID.toString();
        if(this.SRAgencyName != '') payload.agencyName = this.SRAgencyName.toString();
        if(this.SuperAgentType != '') payload.CourierID = this.SuperAgentType.toString();;
        if(this.shippingID != '') payload.ShippingID = this.shippingID;
        if(this.employeeID != '') payload.EmployeeID = this.employeeID;
        if(this.staffDebit != '') payload.SRDebitID = this.staffDebit;
        if(this.debitMode != '') payload.debitMode = this.debitMode;
        if(this.Vertical != '') payload.Vertical = this.Vertical;
        payload.pageNo = this.pageno;
        payload.pageSize = 10;
        payload.status = this.status
        this.ApproveResultResponse = [];
        payload.exportFlag = '0'

        axios({
            method: 'POST',
            url: apiUrl.api_url + 'lostshipmentinfo/FinanceApproval/shipmentDebitList',
            data:payload
          })
          .then(result => {
            if(result.data.code == 200){
              if(result.data.data.length > 0 ){
                result.data.data.forEach(data=>{
                  let temp = '';
                  for (var i = 0; i < data.ShippingID.length; i++) {
                    temp += data.ShippingID[i];
                  }
                  data.Shippingid = temp;
                });
                this.loader = false;
                  this.HRDebitData = result.data.data;
                  this.totalRecords = result.data.TotalCount
                  let totalRows = result.data.TotalCount;
                  if (totalRows < 10) {
                      this.pagecount = 1;
                  } else {
                      this.pagecount = Math.ceil(totalRows / 10)
                  }
              }
              else {
                this.$alertify.error("No Pending Approval");
              }
            }
            else {
                this.HRDebitData = [];
                this.searchflag=false;
                this.loader = false;
                this.$alertify.error(result.data.message != undefined ? result.data.message : "No Pending Approval");
            }
          }, error => {
            this.loader = false;
            console.error(1,error)
          });
        },
        getShipmentAttachmentPopup(shippingID, isTransitePath, debitType){
          this.attachmentLoader = true
          this.getAttachmentFlag= true
          this.getAttachmentListData = [];

            let data={
              ShippingID: shippingID
            }
            axios.post(apiUrl.api_url + 'Lost/ShippindID/AttachmentDownload',data)
              .then((response) => {

                  if(response.data.code == 200){
                     // this.getAttachmentListData = response.data.data ;
                     this.getAttachmentListData = response.data.data.lostImages;
                     this.getInvestigationImgs = response.data.data.investigationImages
                     console.log("Images", this.getAttachmentListData, this.getInvestigationImgs);
                     if(this.getAttachmentListData.length !=0){
                       this.getAttachmentListData.forEach(ele=>{
                         // const extension = ele.filePath.split('.').pop().toLowerCase();
                         const extension = this.getFileExtension(ele.filePath);
                         const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'tiff'];
                         const videoExtensions = ['mp4', 'avi', 'mkv', 'mov', 'wmv', 'flv', 'webm', 'ogg'];
                         const pdfExtensions = ['pdf', 'docx'];
                         console.log("extension =============>>", extension);
                         // Determine the file type based on the extension
                         if (imageExtensions.includes(extension)) {
                             ele.fileType='image'
                         } else if (videoExtensions.includes(extension)) {
                             ele.fileType='video'
                         } else if (pdfExtensions.includes(extension)) {
                            ele.fileType='pdf'
                         }
                       })
                     }
                     console.log("this.getAttachmentListData ---------->>", this.getAttachmentListData);
                     if(this.getInvestigationImgs.length!=0){
                       console.log(this.getInvestigationImgs);

                       this.getInvestigationImgs.forEach(ele=>{
                         const extension = this.getFileExtension(ele.filePath);
                         const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'tiff'];
                         const videoExtensions = ['mp4', 'avi', 'mkv', 'mov', 'wmv', 'flv', 'webm', 'ogg'];
                         const pdfExtensions = ['pdf', 'docx'];

                         // Determine the file type based on the extension
                         if (imageExtensions.includes(extension)) {
                             ele.fileType='image'
                         } else if (videoExtensions.includes(extension)) {
                             ele.fileType='video'
                         } else if (pdfExtensions.includes(extension)) {
                            ele.fileType='pdf'
                         }
                       })
                     }

                  } else {
                    this.getAttachmentListData = [];
                  }
                  this.attachmentLoader = false;
                })
              .catch((httpException) => {
                   this.attachmentLoader = false;
                  console.error('exception is:::::::::',httpException)
              });
        },
        closeAttachmentPopup(){
         this.getAttachmentFlag = false
        },
        getFormatedDate(date){
          let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
          return year+'/'+month+'/'+day;
        },
        customizedDebit(){
          this.customizedDebitValueData[0].remainingAmount = parseInt(this.shippingDetailes.ConcernPersonDebitAmount)
          - parseInt(this.customizedDebitValue);
          if(parseInt(this.customizedDebitValue) <= parseInt(this.shippingDetailes.ConcernPersonDebitAmount)
          && parseInt(this.customizedDebitValue) >= 5000 )
          {
            this.customizedDebitErrorFlag = true;
          }else {
            this.customizedDebitErrorFlag = '';
          }
        },
        getSuperAgentList(){
          this.SuperAgentTypeData = [];
          axios({
              method: 'POST',
              url: apiUrl.api_url + 'external/OutSourcingAgentLIst',
              data:{
                HubID : this.hubname,
                EntityType:"Agent"
              }
            })
            .then(async result => {
              if(result.data.data.length > 0){
                this.SuperAgentArray = result.data.data;
                for (var i = 0; i < this.SuperAgentArray.length; i++) {
                  this.SuperAgentTypeData.push({
                    value: this.SuperAgentArray[i].id,
                    text: this.SuperAgentArray[i].name
                  })

                }
              }
              else {
                this.SuperAgentTypeData = [];
              }
            }, error => {
              console.error(1,error)
            });
        },
        HRApproveAllRecords(){
          if(this.selectedItems.length != 0){
            let makeArrayToString = this.selectedItems.toString();
            let backStringToArray = makeArrayToString.split(',');

            let requestPayload = {
              shipmentDebitNoteIds: backStringToArray,
              status: 'AccountCloseDebit',
              lastModifiedBy: this.localusermailid,
            }
            this.confirmFinanceBeforeDebit(requestPayload)
          } else {
            this.$alertify.error("Please select at least one record");
          }
        },
        confirmFinanceBeforeDebit(getPayload){
          let message = {
            title: '',
            body: `<p>Are you sure, Do you really want to raise debit request.</p>`,
          }
          let res = this.$dialog.confirm(message, {
            html: true,
            animation: 'bounce',
            backdropClose: true,
            okText: 'Yes',
            cancelText: 'No',
            reverse: true
            //loader: true
          })
          .then(dialog => {
            // console.log('set Request', getPayload);
            // console.log('Yes...');
            this.confirmedDebit(getPayload);
          })
          .catch(() => {
            console.log('cancelled Approve Request.!');
          })
        },
        confirmedDebit(reqPayloads){
          try {
            this.loader = true;
            this.ApproveResultResponse = [];
            // console.log('reqPayloads ----->>>>', reqPayloads);
            this.debitNoteId = reqPayloads.shipmentDebitNoteIds
            let reqPayloadApporve = {
              "shipmentDebitNoteIds": reqPayloads.shipmentDebitNoteIds,
              "status": reqPayloads.status,
              "lastModifiedBy": reqPayloads.lastModifiedBy
            }
            if(this.invoiceNo != '') {
              reqPayloadApporve.invoiceNo = this.invoiceNo
            }
            axios({
                method: 'POST',
                url: apiUrl.api_url + 'lostshipmentinfo/FinanceApproval/approveDebit',
                data:reqPayloadApporve
              }).then(approveFAResult => {
                // console.log('approveFAResult ==>', approveFAResult.data);
                if (approveFAResult.data.code == 200) {
                    let masterID = String(this.debitNoteId)
                    let TrackerInfo = {
                    projectname:"Last Mile",
                    type:"Web",
                    userid:this.localuserid,
                    username:this.localusermailid,
                    meta :
                    {
                      "event":"financeApproval",
                      "invoiceNo" :this.invoiceNo,
                      "shipmentDebitNoteIds" : masterID
                    }
                  }
                  this.PageTracker(TrackerInfo);
                   // this.$alertify.success(approveFAResult.data.message);
                   this.HRApproveAllRecord = false;
                   // this.HRApproveFilter();
                }else {
                  this.$alertify.error(approveFAResult.data.message);
                }
                this.ApproveResultResponse = approveFAResult.data.data;
                this.loader = false;
              }, error => {
                console.error(1,error)
                this.loader = false;
              });
          } catch(e) {
            this.loader = false;
            console.log('error logs', e);
          }
        },
        getPaginationData(pageNum) {
          this.pageno = pageNum;
          this.exportFlag = false
          this.HRApproveFilter();
        },
        getEmployeeType(){
            let apiendpoint = 'external/GetEmployeeTypeMasterList';
            if (keycloak.enableKavach) {
              apiendpoint = 'user/migration/getemployeetypemasterlist';
            }
            axios.post(apiUrl.api_url + apiendpoint, {"appkey":"$LAST$Mile%#$"})
              .then(result => {
                //if(result.data.data.rows >0){
                 if(result.data.code ==200){
                  this.EmpTypeArray = result.data.data.rows;
                  //this.hubArray=response.data.data;
                  for (var i = 0; i < this.EmpTypeArray.length; i++) {
                    this.debitFromTypeList.push({
                      value: this.EmpTypeArray[i].EmpTypeId,
                      text: this.EmpTypeArray[i].EmpTypeName
                    })

                  }
                }
                else {
                  this.debitFromTypeList = [];
                }
              }, error => {
                console.error(1,error)
              });
        },

        getHubList(hubZoneID){

          let url = 'UpdateShipment/gethublist';
          if(hubZoneID != 'hubList') url = `external/getzonewisehublist?zoneid=${hubZoneID}`;
          axios.get(apiUrl.api_url + url)
            .then((response) => {
                if(response.data.code ==200){
                    this.hubArray=response.data.data;

                    for (var i = 0; i < this.hubArray.length; i++) {
                      this.hubList.push({
                        value: this.hubArray[i].HubID,
                        text: this.hubArray[i].HubName
                      })
                    }
                    for (var i = 0; i < this.hubList.length; i++){

                      if(this.hubList[i].value == this.hubID){
                        this.hublistObj = { value: this.hubList[i].value ,text: this.hubList[i].text}
                        this.hubname = this.hubList[i].value
                      }

                    }
                }
                else {
                    this.hubList=[];
                }
            })
            .catch((httpException) => {
                  this.$alertify.error("Hub List not found");
                  console.error('exception is:::::::::', httpException)
            })
        },
        getSRAgencyList(hubid,EmpType){
          let emptype = []
          if(EmpType){
            emptype = [EmpType]
          }
          this.getEmpList = []
          let apiendpoint = 'external/getHubEmpDetails';
          if (keycloak.enableKavach) {
            apiendpoint = 'user/migration/gethubempdetails';
          }
          axios({
              method: 'POST',
              url: apiUrl.api_url + apiendpoint,
              data:{"Emppayload":{"appkey":"$LAST$Mile%#$","HubId":[ hubid ],"EmpType":emptype}}
            })
            .then(async result => {
              if(result.data.code == 200){
                this.hubArray = result.data.data;
                this.hubArray.forEach((obj) => {
                  this.getEmpList.push({
                    value: obj.userid,
                    text: `${obj.username} - ${obj.userid}`
                  })
                })
                // for (var i = 0; i < this.hubArray.length; i++) {
                //   this.SRAgencyList.push({
                //     value: this.hubArray[i].userid,
                //     text: this.hubArray[i].username
                //   })
                // }
              }
              else {
                this.getEmpList = [];
              }
            }, error => {
              console.error(1,error)
            });
        },
        getEmpListing(){
          // alert('hello');
          // console.log('hubList', this.hubList);
          let hubArray = [];
          let debitFromTypeArr = [];
          let hubID = this.hubList.find(tempObj => tempObj.value == this.hubname );
          hubArray.push(hubID);
          debitFromTypeArr.push(this.debitFromType);

          let apiendpoint = 'external/getHubEmpDetails';
          if (keycloak.enableKavach) {
            apiendpoint = 'user/migration/gethubempdetails';
          }
          axios({
              method: 'POST',
              url: apiUrl.api_url + apiendpoint,
              data:{
                "HubId" : hubArray,
                "EmpType" : debitFromTypeArr
              }
            })
            .then(async result => {
              if(result.data.length > 0){

                if(result.data.code == 200){
                  this.getEmpList = await result.data.data;
                }else{
                  this.getEmpList = [];
                }
              }
              else {
                this.getEmpList = [];
              }
            }, error => {
              this.getEmpList = [];
              console.error(1,error)
            });

        },
        selectItems(ev) {
            this.selectedItems = [];
            if (ev.target.checked == true) {
                for (let i in this.HRDebitData) {
                  this.selectedItems.push(this.HRDebitData[i].srid.toString());
                }
            }
        },
        getCSVData(){
          var csvData = this.exportCSVData;
          var today = new Date();
          var dd = today.getDate();
          var mm = today.getMonth() + 1;
          var yyyy = today.getFullYear();
          var today = dd + "" + mm + "" + yyyy;
          var data, filename, link;
          filename = "LostDebitShipments_RMDebit" + today + ".csv";
          var csv = this.convertArrayOfObjectsToCSV({
            data: csvData
          });
          if (csv == null) return;
          filename = filename || "export.csv";
          if (!csv.match(/^data:text\/csv/i)) {
            csv = "data:text/csv;charset=utf-8," + csv;
          }
          data = encodeURI(csv);
          link = document.createElement("a");
          link.setAttribute("href", data);
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          link.removeChild(link);
        },
        async exportCSV() {
          if(this.HRDebitData.length == 0 ){
            this.$alertify.error("No record to Download");
          }

          this.searchflag=true;
          this.loader = true;
          let payload = {};
          if(this.fromDate != '') payload.fromDate = this.getFormatedDate(this.fromDate);
          if(this.toDate != '') payload.toDate = this.getFormatedDate(this.toDate);
          if(this.debitFrom != '') payload.debitFrom = this.debitFrom;
          if(this.hubname != '') payload.ServiceCenterName = this.hubname.toString();
          if(this.employeeID != '') payload.EmployeeID = this.employeeID.toString();
          if(this.SRAgencyName != '') payload.agencyName = this.SRAgencyName.toString();
          if(this.SuperAgentType != '') payload.CourierID = this.SuperAgentType.toString();;
          if(this.shippingID != '') payload.ShippingID = this.shippingID;
          if(this.employeeID != '') payload.EmployeeID = this.employeeID;
          if(this.staffDebit != '') payload.SRDebitID = this.staffDebit;
          if(this.debitMode != '') payload.debitMode = this.debitMode;
          payload.pageNo = this.pageno;
          payload.pageSize = 10;
          payload.status = this.status
          this.ApproveResultResponse = [];
          payload.exportFlag = '1'

          axios({
              method: 'POST',
              url: apiUrl.api_url + 'lostshipmentinfo/FinanceApproval/shipmentDebitList',
              data:payload
            })
            .then(result => {
              if(result.data.code == 200){
                if(result.data.data.length > 0 ){
                  result.data.data.forEach(data=>{
                    let temp = '';
                    for (var i = 0; i < data.ShippingID.length; i++) {
                      temp += data.ShippingID[i];
                    }
                    data.Shippingid = temp;
                  });
                  this.loader = false;

                  this.exportCSVData = result.data.data;
                  this.getCSVData()
                }
                else {
                  this.$alertify.error("No Pending Approval");
                }
              }
              else {
                  this.exportCSVData = [];
                  this.searchflag=false;
                  this.loader = false;
                  this.$alertify.error(result.data.message != undefined ? result.data.message : "No Pending Approval");
              }
            }, error => {
              this.loader = false;
              console.error(1,error)
            });
        },
        convertArrayOfObjectsToCSV(args) {
           var result, ctr, keys, columnDelimiter, lineDelimiter, data;
           data = args.data || null;
           if (data == null || !data.length) {
             return null;
           }
           columnDelimiter = args.columnDelimiter || ",";
           lineDelimiter = args.lineDelimiter || "\n";
           keys = Object.keys(data[0]).slice(0,-1);
           result = "";
           result += keys.join(columnDelimiter);
           result += lineDelimiter;
           data.forEach(function(item) {
             ctr = 0;
             keys.forEach(function(key) {
               if (ctr > 0) result += columnDelimiter;
               if (item[key] != null) {
                 result += '"' + item[key] + '"';
               }
               ctr++;
             });
             result += lineDelimiter;
           });
           return result;
         },
         raiseHRDebitNotePopup(srDetail){
           this.comment='';
           this.raiseHRDebitNotePopupflag= true;
           axios({
               method: 'POST',
               url: apiUrl.api_url + 'shipmetsDebitDeatils',
               data:{
                 "srID" : srDetail.srid.toString(),
                 "shippinID" : srDetail.ShippingID
               }
             })
             .then(async result => {
               if(result.data.data.length > 0){
                 if(result.data.code == 200){
                   this.shippingDetailes = srDetail;
                   this.DetailsofMarkedDebit = await result.data.data;
                   let paidAmount = 0;
                   result.data.data.forEach(remainingPaidAmount =>{
                     paidAmount += remainingPaidAmount.PaidAmount
                   })
                   let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
                    'August', 'September', 'October', 'November', 'December'];
                   let d = new Date(this.shippingDetailes.lastmodifieddate);
                   let totalvalue = Math.trunc(this.shippingDetailes.RemainingAmount);
                   if( totalvalue  > 5000 ){
                     this.paymentOption = "customizedDebitValue";
                     let temp = {
                       noOfCases : this.shippingDetailes.NoOfCases,
                       totalAmount : this.shippingDetailes.ConcernPersonDebitAmount,
                       paidAmount : paidAmount,
                       remainingAmount : parseInt(this.shippingDetailes.ConcernPersonDebitAmount) - 5000,
                       month : (months[d.getMonth()] + '-' + d.getFullYear())
                     }
                     this.customizedDebitValueData.push(temp);
                   }

                 }else{
                   this.DetailsofMarkedDebit = [];
                 }
               }
               else {
                 this.DetailsofMarkedDebit = [];
               }
             }, error => {
               console.error(1,error)
             });
         },
         shipmetsDeatilespopup(shippingID){
           this.shipmetDeatileFlag=true;
           axios({
               method: 'POST',
               url: apiUrl.api_url + 'customizeValueDebitDetaile',
               data:{
                 "shippingID" : shippingID
               }
             })
             .then(async result => {
                 if(result.data.code == 200){
                   this.shipingInfo = result.data.data;
                 }else{
                   this.shipingInfo = [];
                 }
             }, error => {
               console.error(1,error)
             });
         },
         closepopupForShipment(){
           this.raiseHRDebitNotePopupflag= true;
           this.shipmetDeatileFlag=false;
           // var element = document.getElementById("test123");
           // element.classList.add("show1");
           document.getElementById('raiseHRDebitNotePopupDiv').style.display="block";
           document.getElementById('raiseHRDebitNotePopupDiv').style.overflow="auto";
         },
         closeonPopupforraiseHRDebitNote() {
           this.raiseHRDebitNotePopupflag= false;
           this.customizedDebitErrorFlag = true;
           this.paymentOption = "totalPayment";
           this.customizedDebitValueData = [] ;
           this.DetailsofMarkedDebit=[];
           this.customizedDebitValue = 5000;
           this.$validator.reset();
           this.errors.clear();
         },
        raiseDebit(obj){
          if(parseInt(obj.ConcernPersonDebitAmount) >= parseInt(obj.customizedDebitValue) && parseInt(obj.customizedDebitValue) >= 5000 ){
            axios({
                method: 'POST',
                url: apiUrl.api_url + 'shipmetsDebitDeatils',
                data:{
                  "srID" : obj.srid.toString(),
                  "shippinID" : obj.ShippingID
                }
              })
              .then(async result => {
                let hrApprovePayload = [];
                result.data.data.forEach((res)=>{
                  if(obj.customizedDebitValue != 0){
                    if(parseInt(obj.customizedDebitValue) >= parseInt(res.RemainingAmount)){
                      let amount = parseInt(obj.customizedDebitValue) - parseInt(res.RemainingAmount);
                      let objTemp = {
                        shipmentLostMasterID: res.ShipmentLostMasterID,
                        shipmentLostDetailsID: res.ShipmentLostDetailsID,
                        shippingID: res.ShippingID,
                        debitAmount: res.RemainingAmount.toString(),
                        remainingAmount: res.RemainingAmount,
                        createdBy: this.localusermailid
                      }
                      hrApprovePayload.push(objTemp);
                      obj.customizedDebitValue = amount;

                    }
                    else if (parseInt(obj.customizedDebitValue) < parseInt(res.RemainingAmount)) {
                      let amount = parseInt(res.RemainingAmount) - parseInt(obj.customizedDebitValue);
                      let objTemp = {
                        shipmentLostMasterID: res.ShipmentLostMasterID,
                        shipmentLostDetailsID: res.ShipmentLostDetailsID,
                        shippingID: res.ShippingID,
                        debitAmount: obj.customizedDebitValue.toString(),
                        remainingAmount: res.RemainingAmount,
                        createdBy: this.localusermailid
                      }
                      hrApprovePayload.push(objTemp);
                      obj.customizedDebitValue = 0;
                    }
                  }
                });
                axios({
                    method: 'POST',
                    url: apiUrl.api_url + 'approveDebitAgaianstShipmets',
                    data:{
                      "shipmetsDebitDeatils" : hrApprovePayload,
                    }
                  }).then(async approveHRresult => {
                    if (approveHRresult.data.code == 200) {
                       this.$alertify.success(approveHRresult.data.message);
                       this.HRApproveFilter();
                    }else {
                      this.$alertify.error(approveHRresult.data.message);
                    }
                  }, error => {
                    console.error(1,error)
                  });
              }, error => {
                console.error(1,error)
              });
          }
          else {
            axios({
                method: 'POST',
                url: apiUrl.api_url + 'shipmetsDebitDeatils',
                data:{
                  "srID" : obj.srid.toString(),
                  "shippinID" : obj.ShippingID
                }
              })
              .then(async result => {
                let hrApprovePayload = [];
                result.data.data.forEach((res)=>{
                      let objTemp = {
                        shipmentLostMasterID: res.ShipmentLostMasterID,
                        shipmentLostDetailsID: res.ShipmentLostDetailsID,
                        shippingID: res.ShippingID,
                        debitAmount: res.DebitAmount.toString(),
                        remainingAmount: res.RemainingAmount,
                        createdBy: this.localusermailid
                      }
                      hrApprovePayload.push(objTemp);
                });
                axios({
                    method: 'POST',
                    url: apiUrl.api_url + 'approveDebitAgaianstShipmets',
                    data:{
                      "shipmetsDebitDeatils" : hrApprovePayload,
                    }
                  }).then(async approveHRresult => {
                    if (approveHRresult.data.code == 200) {
                       this.$alertify.success(approveHRresult.data.message);
                       this.HRApproveFilter();
                    }else {
                      this.$alertify.error(approveHRresult.data.message);
                    }
                  }, error => {
                    console.error(1,error)
                  });
              }, error => {
                console.error(1,error)
              });

          }

        },
        validateForm(scope) {
          this.$validator.validateAll(scope).then(result => {
            if (result) {
                  let obj={
                    name:this.shippingDetailes.name,
                    Designation:this.shippingDetailes.Designation
                  }
                let objTemp ={
                  srid  : this.shippingDetailes.srid ,
                  ShippingID : this.shippingDetailes.ShippingID,
                  ConcernPersonDebitAmount : this.shippingDetailes.ConcernPersonDebitAmount,
                  customizedDebitValue : this.customizedDebitValue
                }
                this.raiseDebit(objTemp);
                this.closeonPopupforraiseHRDebitNote();
            }
          }).catch(() => {
            console.log('errors exist', this.errors)
          });
        },
        srDebitOnChangeReset(){
          this.debitFromType = ''
          this.debitFromTypeObj = {}
          this.staffDebit = ''
          this.staffDebitObj = {}
        },
        coloaderReset(){
          this.ColoaderObj = {}
          this.Coloader = ''
        },
        superAgentReset(){
          this.SuperAgentObj = {}
          this.SuperAgentType = ''
        },
        networkVendorReset(){
          this.NetworkVendorObj = {}
          this.NetworkVendor = ''
        },
        VehicleVendorReset(){
          this.localVendorObj = {}
          this.localVendor = ''
        },
        clear(){
          // this.debitModeObj = {}
          this.Vertical = '',
          this.debitModeObj = { value: "",text: ""}
          this.debitMode = ''
          this.StatusObj = {},
          this.status = ''
          this.fromDate='';
          this.toDate='';
          this.debitFrom='';
          this.debitFromObj = {value: "",text: "" }
          this.shippingID='';
          this.employeeID='';
          this.SRAgencyName='';
          this.HRApproveAllRecord='';
          this.selectedItems=[];
          this.selectAllItems=false;
          this.searchflag=false;
          this.HRDebitData=[];
          this.comment='';
          this.DetailsofMarkedDebit=[];
          this.shippingDetailes={};
          this.paymentOption = "totalPayment",
          this.pageno = 1;
          this.pagecount = 0;
          this.customizedDebitErrorFlag = '';
          this.srDebitOnChangeReset()
          this.coloaderReset()
          this.superAgentReset()
          this.networkVendorReset()
          this.VehicleVendorReset()
          this.clearDebitData()
          this.$validator.reset();
          this.errors.clear();
        }
      }
}
$('.pane-hScroll').scroll(function() {
  $('.pane-vScroll').width($('.pane-hScroll').width() + $('.pane-hScroll').scrollLeft());
});



// WEBPACK FOOTER //
// ./src/views/components/LOST/FinanceApprove/FinanceApprove.component.js